import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Ao trocar de página, volta ao topo. Não age na abertura do site (o visitante pode já ter
 * rolado a página pré-renderizada) nem em links para âncoras, como "/#planos".
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation()
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (!hash) window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
